import { UserType } from '../types';
const restrictedUsertypes: UserType[] = ['free', 'anonymous'];

export function isRestrictedUserType(userType: UserType, isClub = false, isMatrix = false): boolean {
  if (isClub && !isMatrix) {
    return false;
  }
  return restrictedUsertypes.includes(userType);
}
